export const SS_TOKEN = "SS_TOKEN";
export const SS_REF_HASH_ID = "SS_REF_HASH_ID";
export const SS_EMAIL = "SS_EMAIL";
export const SS_FIRST_NAME = "SS_FIRST_NAME";
export const SS_LAST_NAME = "SS_LAST_NAME";
export const SS_ROLE = "SS_ROLE";
export const SS_MOBILE_NUMBER = "SS_MOBILE_NUMBER";
export const SS_UPI_ENABLED = "SS_UPI_ENABLED";
export const SS_CASH_FREE = "SS_CASH_FREE";

export const SS_INTERVAL_ID = "SS_INTERVAL_ID";
export const SS_INTERVAL_TIME = "SS_INTERVAL_TIME";
